import script from "./circleProgress.vue?vue&type=script&setup=true&lang=js"
export * from "./circleProgress.vue?vue&type=script&setup=true&lang=js"

import "./circleProgress.vue?vue&type=style&index=0&id=5b8e3f72&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b8e3f72"]])

export default __exports__